<template>
  <popup-layout title="증명서 발급" :is-show="isShow" width="80vw" max-width="500px">
    <template v-slot:content>
     <v-container>
       <v-row>
         <v-col cols="12">
           <div class="file-input-layout">
             <span>발급</span>
             <v-file-input
                 v-model="files"
                 accept=".jpg, .jpeg, .png, .pdf"
                 small-chips show-size multiple clearable outlined
                 prepend-icon="" prepend-inner-icon="mdi-paperclip" placeholder="파일을 첨부해주세요."
                 @change="fileUpload"
             >
               <template v-slot:selection="{ text, index }">
                 <v-chip
                     small
                     text-color="white"
                     color="#295671"
                     close @click:close="removeFile(index)"
                 >
                   {{ text }}
                 </v-chip>
               </template>
             </v-file-input>
           </div>
         </v-col>
         <v-col cols="12">
           <span>거절</span>
           <v-text-field
               v-model="resNote"
               outlined hide-details
               background-color="white"
           />
         </v-col>
       </v-row>
     </v-container>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="issueFile">
          발급
        </v-btn>
        <v-btn class="button delete" outlined @click="issueReject">
          거절
        </v-btn>
        <v-btn class="button delete" outlined @click="close">
          닫기
        </v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";

export default {
  name: "CertificateIssue",
  components: {PopupLayout},
  props: ["isShow", "selectData"],
  data() {
    return {
      resNote: "",
      files: [],
      base64Files: {}
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  methods: {
    async fileUpload(files) {
      this.files = files;
      this.base64Files = {};

      for (const file of Array.from(files)) {
        try {
          const base64String = await this.getFileBase64(file);

          const removeFileTypeNm = file.name.replace(/\.[^/.]+$/, '');

          const fileType = file.type.replace(/^.*\//, '');

          this.base64Files = {
            fileNm: removeFileTypeNm,
            fileType: fileType,
            fileStr: base64String
          };
        } catch (error) {
          await this.showAlert({message: `${error.response.data.message}`});
        }
      }
    },
    getFileBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    removeFile(index) {
      const removeFile = this.files[index];
      this.files.splice(index, 1);

      if (removeFile.type.startsWith('image/')) {
        this.previews.splice(index, 1);
      }
    },
    issueFile() {
      this.showConfirm({
        message: `증명서 발급을 승인하시겠습니까?`,
        successCallback: () => {
          this.certificateProcess("COMP");
        },
        failCallback: () => {
          return false;
        }
      });
    },
    async certificateProcess(state) {
      const process = {
        certificateId: Number(this.selectData.certificateId),
        state: state,
        reqId: this.selectData.reqId,
        resNote: this.resNote,
        resId: this.memberId,
        fileDto: this.base64Files
      };
      try {
        await axiosInstance.post("/admin/certificate/process", process)
            .then(() => {
              this.showAlert({
                message: "처리가 완료되었습니다",
                successCallback: () => {
                  this.setDefaultData();
                  this.$emit("close");
                  this.$emit("refresh");
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    issueReject() {
      this.showConfirm({
        message: `증명서 발급을 거절하시겠습니까?`,
        successCallback: () => {
          this.certificateProcess("REJECT");
        },
        failCallback: () => {
          return false;
        }
      });
    },
    setDefaultData() {
      this.files = [];
      this.resNote = "";
    },
    close() {
      this.setDefaultData();
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>